// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"

import { fetchMemberPublicDoctors } from "@core/api/doctorApi"
import { DoctorSerializer } from "@/types/doctor"

interface DoctorPayload {
  doctors: DoctorSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: DoctorPayload = {
  doctors: null,
  loading: false,
  error: null,
}

const doctorSlice = createSlice({
  name: "encounter",
  initialState,
  reducers: {
    clearDoctors(state) {
      state.doctors = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchMemberPublicDoctors.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMemberPublicDoctors.fulfilled, (state, action) => {
        state.loading = false
        state.doctors = action.payload
        // console.debug("의사 목록", state.doctors)
      })
      .addCase(fetchMemberPublicDoctors.rejected, (state, action) => {
        state.loading = false
        state.doctors = null
        state.error = (action.payload as string) || action.error.message || "오류 "
      })
  },
})

export const { clearDoctors, setLoading, setError } = doctorSlice.actions

export default doctorSlice.reducer
